import React from 'react';
import AboutForm from '../components/AboutElements/AboutForm';
import AboutHome from '../components/AboutElements/AboutHome';

const AboutUs = () => {
    return (
        <div className="section_sm reserve_table bg_image_1">
            <div className="container">
                <AboutForm />
                <AboutHome />
            </div>
        </div>
    );
};

export default AboutUs;